import { jsx as k } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import w from "classnames";
import o from "./index.es589.js";
import { onKeyDownEnter as D } from "./index.es500.js";
const y = "link-component", $ = u(
  ({
    color: n = "brand",
    size: e = "medium",
    weight: i = "regular",
    hideUnderline: a = !0,
    testId: m = y,
    children: l,
    disabled: r,
    onClick: t,
    isEllipsis: s,
    tabIndex: p = 0,
    ...d
  }, f) => /* @__PURE__ */ k(
    "a",
    {
      ...d,
      className: w(
        o.link,
        o[`color-${r ? "disabled" : n}`],
        o[`size-${e}`],
        o[`weight-${i}`],
        {
          [o["no-underline"]]: a,
          [o.ellipsis]: s
        }
      ),
      "aria-disabled": r,
      "data-testid": m,
      role: "link",
      "data-pl-size": e,
      "data-pl-weight": i,
      onClick: r ? void 0 : t,
      onKeyDown: r ? void 0 : (c) => D(c, t),
      ref: f,
      tabIndex: p,
      children: l
    }
  )
);
export {
  y as LINK_DEFAULT_TESTID,
  $ as Link
};
//# sourceMappingURL=index.es62.js.map
